import { render, staticRenderFns } from "./EmbargosEmergenciaisIpaam.vue?vue&type=template&id=26db042b&lang=pug"
import script from "./EmbargosEmergenciaisIpaam.vue?vue&type=script&lang=js"
export * from "./EmbargosEmergenciaisIpaam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports